/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/13
 */
import './index.css';
import React, {Component} from 'react';
import classNames from 'classname';
import {connect} from 'react-redux';
import {selectOption} from '../../../actions/step';

class SelectItem extends Component {
  handleItemClick = () => {
    const { open, index, selectOption, id, pid, selected, type, disabled, name } = this.props;
    if (disabled) {
      return false;
    }
    if (!selected && open) {
      open(index + 1);
    }
    selectOption(pid, id, name, type);
  };
  render () {
    const { name, remark, selected, disabled } = this.props;
    return <div className={classNames('mcycle-step-select-item', {
      'selected': selected,
      'disabled': disabled
    })} onClick={this.handleItemClick}>
      <div className="mcycle-step-select-item-wrap">
        <p className="mcycle-step-select-item-title">{name}</p>
        {remark ? <p className="mcycle-step-select-item-desc">{remark}</p> : null}
      </div>
    </div>
  }
}

export default connect(
  null,
  {selectOption}
)(SelectItem);




// WEBPACK FOOTER //
// ./src/components/step1/selectItem/index.js